import { useState, useEffect } from 'react';
import AdminLayout from '../components/AdminLayout';
import axios from 'axios';
import { Package, FolderOpen, Users, TrendingUp, DollarSign } from 'lucide-react';
import { getCurrencySymbol } from '../utils/currency';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    products: 0,
    categories: 0,
    users: 0,
    sales: 0,
    totalRevenue: 0
  });
  const [currency, setCurrency] = useState('BRL');

  useEffect(() => {
    fetchStats();
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${API}/settings`);
      setCurrency(response.data.currency || 'BRL');
    } catch (error) {
      console.error('Erro ao carregar configurações');
    }
  };

  const fetchStats = async () => {
    try {
      const [productsRes, categoriesRes, usersRes, salesRes] = await Promise.all([
        axios.get(`${API}/products`),
        axios.get(`${API}/categories`),
        axios.get(`${API}/users`),
        axios.get(`${API}/sales`)
      ]);

      const totalRevenue = salesRes.data.reduce((sum, sale) => sum + sale.total, 0);

      setStats({
        products: productsRes.data.length,
        categories: categoriesRes.data.length,
        users: usersRes.data.length,
        sales: salesRes.data.length,
        totalRevenue
      });
    } catch (error) {
      console.error('Erro ao carregar estatísticas:', error);
    }
  };

  const currencySymbol = getCurrencySymbol(currency);

  const cards = [
    { icon: Package, label: 'Produtos', value: stats.products, color: '#FF5500' },
    { icon: FolderOpen, label: 'Categorias', value: stats.categories, color: '#22c55e' },
    { icon: Users, label: 'Usuários', value: stats.users, color: '#3b82f6' },
    { icon: TrendingUp, label: 'Vendas', value: stats.sales, color: '#a855f7' },
    { icon: DollarSign, label: 'Receita Total', value: `${currencySymbol} ${stats.totalRevenue.toFixed(2)}`, color: '#f59e0b', isRevenue: true },
  ];

  return (
    <AdminLayout title="Dashboard">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {cards.map((card, index) => {
          const Icon = card.icon;
          return (
            <div
              key={index}
              data-testid={`stat-card-${card.label.toLowerCase()}`}
              className="bg-[#18181b] border border-white/10 rounded-xl p-6 hover:border-white/20 transition-all"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${card.color}20` }}>
                  <Icon className="w-6 h-6" style={{ color: card.color }} />
                </div>
              </div>
              <h3 className="text-white/60 font-inter text-sm mb-1">{card.label}</h3>
              <p className={`font-bold font-oswald text-white ${card.isRevenue ? 'text-2xl' : 'text-4xl'}`}>{card.value}</p>
            </div>
          );
        })}
      </div>

      <div className="mt-8 bg-[#18181b] border border-white/10 rounded-xl p-6">
        <h3 className="text-xl font-oswald font-bold text-white mb-4">Bem-vindo ao Painel Admin</h3>
        <p className="text-white/60 font-inter">
          Use o menu lateral para gerenciar categorias, produtos, usuários, visualizar relatórios e configurar o sistema.
        </p>
      </div>
    </AdminLayout>
  );
};

export default AdminDashboard;